import { render, staticRenderFns } from "./ServicePermissionsModalAddForm.vue?vue&type=template&id=7569f8c8&scoped=true&"
import script from "./ServicePermissionsModalAddForm.vue?vue&type=script&lang=js&"
export * from "./ServicePermissionsModalAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7569f8c8",
  null
  
)

export default component.exports